import {
  GET_HOME,
  GET_HOME_SUCCESS,
  GET_HOME_ERROR,
  GET_BOOKMARKS,
  GET_BOOKMARKS_SUCCESS,
  GET_BOOKMARKS_ERROR,
  GET_FOLLOWED_ALERTS_REQUEST,
  GET_FOLLOWED_ALERTS_SUCCESS,
  GET_FOLLOWED_ALERTS_ERROR,
} from "../../constants/actionTypes";

export const homeInitialState = {
  isFetching: false,
  isFetchingBookmarks: false,
  isFetchingAlerts: false,
};

export const reducer = (state, { type, payload }) => {
  switch (type) {
    case GET_HOME: {
      return {
        ...state,
        isFetching: true,
      };
    }
    case GET_HOME_SUCCESS: {
      return {
        ...state,
        ...payload,
        isFetching: false,
      };
    }
    case GET_HOME_ERROR: {
      return {
        ...state,
        isFetching: false,
      };
    }
    case GET_BOOKMARKS: {
      return {
        ...state,
        isFetchingBookmarks: true,
      };
    }
    case GET_BOOKMARKS_SUCCESS: {
      return {
        ...state,
        bookmarks: payload,
        isFetchingBookmarks: false,
      };
    }
    case GET_BOOKMARKS_ERROR: {
      return {
        ...state,
        isFetchingBookmarks: false,
      };
    }
    case GET_FOLLOWED_ALERTS_REQUEST: {
      return {
        ...state,
        isFetchingAlerts: true,
      };
    }
    case GET_FOLLOWED_ALERTS_SUCCESS: {
      return {
        ...state,
        alerts: {
          ...state.alerts,
          ...payload,
        },
        isFetchingAlerts: false,
      };
    }
    case GET_FOLLOWED_ALERTS_ERROR: {
      return {
        ...state,
        isFetchingAlerts: false,
      };
    }
    default:
      return state;
  }
};
